import { ref, get } from 'firebase/database';
import { auth, realtimeDb, signInAnonymously } from './firebase'; // ✅ use the correct name
import moment from 'moment';

export const getAllEntriesGrouped = async () => {
    const u = auth.currentUser;

    if (!u) {
      await signInAnonymously(auth);
    }
  try {
    const usersRef = ref(realtimeDb, 'users'); // ✅ correct db instance
    const snapshot = await get(usersRef);
    const fusersData = snapshot.val();
    
    if (!fusersData) return [];
    // for (const fuserId in fusersData) {
    //   const usersData=fusersData[fuserId] || [];
    //   for (const userId in usersData) {
    //     const locationsByDate = usersData[userId]?.locationsByDate || {};
    //     for (const date in locationsByDate) {
    //       const entries = locationsByDate[date]?.entries || {};
    //       for (const entryId in entries) {
    //         combinedEntries.push({
    //           id: entryId,
    //           fid:fuserId,
    //           userId,
    //           ...entries[entryId],
    //           name:entries[entryId]?.name?.trim(),
    //           date:moment(entries[entryId]?.timestamp).format('DD-MM-YYYY hh:mm A')
    //         });
    //       }
    //     }
    //   }
    // }
    // return combinedEntries.sort((a, b) => b.timestamp - a.timestamp);
    const uniqueMap = new Map();

    for (const fuserId in fusersData) {
      const usersData = fusersData[fuserId] || [];

      for (const userId in usersData) {
        const locationsByDate = usersData[userId]?.locationsByDate || {};

        for (const date in locationsByDate) {
          const entries = locationsByDate[date]?.entries || {};

          for (const entryId in entries) {
            const entry = entries[entryId];
            const key = `${userId}_${moment(entry?.timestamp).format('DD-MM-YYYY hh:mm A')}`; // unique key

            if (!uniqueMap.has(key)) {
              uniqueMap.set(key, {
                id: entryId,
                fid: fuserId,
                userId,
                ...entry,
                name: entry?.name?.trim(),
                date: moment(entry?.timestamp).format('DD-MM-YYYY hh:mm A')
              });
            }
          }
        }
      }
    }

    const combinedEntries = Array.from(uniqueMap.values());

    return combinedEntries.sort((a, b) => b.timestamp - a.timestamp);

  } catch (error) {
    console.error('Error reading from Realtime Database:', error);
    return [];
  }
};

export const getAllEntriesGroupedWithoutLogin = async () => {
    const u = auth.currentUser;

    if (!u) {
      await signInAnonymously(auth);
    }
  try {
    const usersRef = ref(realtimeDb, 'usersLocations');
    const snapshot = await get(usersRef);
    const usersData = snapshot.val();
    console.log(usersData);
    
    if (!usersData) return [];
    // for (const userId in usersData) {
    //   const locationsByDate = usersData[userId]?.locationsByDate || {};
    //   for (const date in locationsByDate) {
    //     const entries = locationsByDate[date]?.entries || {};
    //     for (const entryId in entries) {
    //       combinedEntries.push({
    //         id: entryId,
    //         fid:userId,
    //         userId,
    //         ...entries[entryId],
    //         name:entries[entryId]?.name?.trim(),
    //         date:moment(entries[entryId]?.timestamp).format('DD-MM-YYYY hh:mm A')
    //       });
    //     }
    //   }
    // }
    // return combinedEntries.sort((a, b) => b.timestamp - a.timestamp);
    const uniqueMap = new Map();

    for (const userId in usersData) {
      const locationsByDate = usersData[userId]?.locationsByDate || {};

      for (const date in locationsByDate) {
        const entries = locationsByDate[date]?.entries || {};

        for (const entryId in entries) {
          const entry = entries[entryId];

          const key = `${userId}_${moment(entry?.timestamp).format('DD-MM-YYYY hh:mm A')}`; // unique key

          if (!uniqueMap.has(key)) {
            uniqueMap.set(key, {
              id: entryId,
              fid: userId,
              userId,
              ...entry,
              name: entry?.name?.trim(),
              date: moment(entry?.timestamp).format('DD-MM-YYYY hh:mm A')
            });
          }
        }
      }
    }

    const combinedEntries = Array.from(uniqueMap.values());

    return combinedEntries.sort((a, b) => b.timestamp - a.timestamp);
  } catch (error) {
    console.error('Error reading from Realtime Database:', error);
    return [];
  }
};
